import React, { FC } from "react";
import stl from "./index.module.scss";
import Top from "./Top";
import Main from "./Main";
import Footer from "./Footer";

interface Props {
  hideFooter?: boolean;
  hideAside?: boolean;
}
const Layout: FC<Props> = ({ children, hideFooter, hideAside }) => {
  return (
    <div className={stl.layout}>
      <Top desktopClassName={stl.topDesktop} mobileClassName={stl.topMobile} />
      <Main className={stl.main} hideAside={hideAside}>
        {children}
      </Main>
      {!hideFooter && <Footer className={stl.footer} />}
    </div>
  );
};

export default Layout;
